import {Component, Input, OnInit} from '@angular/core';
import {forkJoin, of} from 'rxjs';
import {catchError} from 'rxjs/operators';
import moment from 'moment';
import 'moment/locale/es';
import {TerceroService} from '../../../../../_services/tercero.service';
import {TerceroTelefonoService} from '../../../../../_services/tercero-telefono.service';
import {SolicitudUnidadCreditoService} from '../../../../../_services/solicitud-unidad-credito.service';
import {AdmsbTitularVista} from '../../../../../_models/admsb-titular';
import {ADMSB_COLOR_POR_METODO, extraerCelular} from '../../admsb-titular.helpers';

@Component({
  selector: 'app-admsb-encabezado',
  templateUrl: './admsb-encabezado.component.html',
  styleUrls: ['./admsb-encabezado.component.scss'],
})
export class AdmsbEncabezadoComponent implements OnInit {

  /** Identificador del tercero titular de la pasarela */
  @Input() idTercero: string;

  /** Nombres de los métodos de pasarela habilitados */
  @Input() metodos = '';

  /** Solicitud de unidad de crédito, usada para validar si el titular tiene billetera */
  @Input() idSolicitudUCUnidadProductiva: string;

  cargandoTitular = true;

  titular: AdmsbTitularVista = {
    nombreCompleto: '',
    fechaCreacion: '',
    numeroDocumento: '',
    telefono: '',
    correo: '',
    ocupacion: '',
    actividadEconomica: '',
    usuario: '',
    metodosHabilitados: [],
  };

  constructor(
    private terceroServicio: TerceroService,
    private terceroTelefonoServicio: TerceroTelefonoService,
    private solUnidadCreditoServicio: SolicitudUnidadCreditoService,
  ) {
  }

  ngOnInit(): void {
    if (this.idTercero) {
      this.cargarTitular(this.idTercero);
    } else {
      this.cargandoTitular = false;
    }
  }

  private cargarTitular(idTercero: string): void {
    forkJoin([
      this.terceroServicio.get(idTercero),
      this.terceroTelefonoServicio.listadoPorTercero(idTercero),
      this.idSolicitudUCUnidadProductiva
        ? this.solUnidadCreditoServicio.validarBilleteraMosi(this.idSolicitudUCUnidadProductiva).pipe(catchError(() => of(false)))
        : of(false),
    ]).subscribe({
      next: ([t, telefonos, tieneBilletera]) => {
        this.titular = {
          nombreCompleto: t.nombreCompleto,
          fechaCreacion: t.fechaCreacion ? moment(t.fechaCreacion).format('DD-MMM-YYYY') : '',
          numeroDocumento: t.numeroDocumento,
          telefono: extraerCelular(telefonos),
          correo: t.correoElectronico,
          ocupacion: t.ocupacion,
          actividadEconomica: t.actividadEconomica,
          usuario: tieneBilletera ? 'Billetera' : '',
          metodosHabilitados: (this.metodos ?? '').split(',').map(m => m.trim()).filter(Boolean).map(nombre => ({
            nombre,
            colorClase: ADMSB_COLOR_POR_METODO[nombre] ?? 'admsb-chip--gris',
          })),
        };
        this.cargandoTitular = false;
      },
      error: () => this.cargandoTitular = false,
    });
  }

}
